export const id = {
  whatsNew: {
    title: "Yang baru",
    intro: "Ini yang baru di Vamos Tamos.",
    teamsTitle: "Simpan tim Anda",
    teamsBody: "Simpan daftar pemain dengan nama dan PIN 4 angka, lalu muat kapan saja.",
    languagesTitle: "Lebih banyak bahasa",
    languagesBody: "Vamos Tamos kini berbicara dalam 6 bahasa, termasuk Jerman dan Indonesia.",
    cta: "Mengerti",
    badge: "Baru",
  },
  common: {
    loading: "Memuat...",
    points: "poin",
    court: "Lapangan",
    team: "Tim",
    player: "Pemain",
    rank: "Peringkat",
    score: "Skor",
    share: "Bagikan hasil",
    linkCopied: "Tautan disalin ke papan klip",
    shareFailed: "Turnamen terlalu besar untuk dibagikan lewat URL. Coba dengan lebih sedikit pemain.",
    and: "dan",
    close: "Tutup",
    save: "Simpan",
    cancel: "Batal",
    back: "Kembali",
    yes: "Ya, Hapus",
    no: "Tidak, Kembali",
    editable: "Dapat diubah",
    buyMeCoffee: "Traktir saya kopi",
  },
  results: {
    leastGames: "Paling sedikit bermain",
    leastGamesTooltip: "Paling sedikit pertandingan dimainkan",
  },
  tournament: {
    new: "Americano atau Mexicano?",
    create: "Buat Turnamen",
    nameRequired: "Nama turnamen wajib diisi",
    tournamentName: "Nama turnamen",
    round: "Ronde",
    completeRound: "Selesaikan Ronde",
    completingRound: "Menyelesaikan...",
    nextRoundReady: "Ronde #{round} siap",
    endTournament: "Akhiri Turnamen",
    formatRequired: "Silakan pilih Americano atau Mexicano",
    enterScores: "Silakan masukkan semua skor sebelum menyelesaikan ronde",
    bench: "Pemain di Bangku Cadangan",
    finalResults: "turnamen",
    finished: "Turnamen Selesai",
    winner: "Pemenang",
    winners: "Pemenang",
    with: "dengan",
    points: "poin",
    summary: "Turnamen selesai dalam {rounds} ronde dengan {players} pemain di {courts} lapangan",
    confirmEnd: "Apakah Anda yakin? Skor dari ronde ini tidak akan dimasukkan ke total skor",
    yes: "Ya",
    no: "Tidak",
    newTournament: 'Mulai Turnamen baru',
    playedMatches: 'Dimainkan',
    pairingComplete: "Pemasangan Selesai",
    roundSaved: "Ronde #{round} disimpan",
    allPlayersPaired: "Turnamen selesai!",
    continueWithNewPairs: "Lanjutkan Turnamen",
    viewResults: "Lihat Hasil",
    tournamentEnded: "Turnamen Berakhir",
    roundSettings: "Pengaturan ronde",
    pointsModeLabel: "Berbasis poin hingga {points}",
    timeModeLabel: "Berbasis waktu, {minutes} mnt",
    timer: "Pengatur waktu: {time}",
    timerStatus: "Pengatur waktu ronde",
    timeUp: "Waktu habis! Silakan selesaikan ronde dan masukkan skor.",
    editRoster: "Ubah Daftar Pemain",
    editRosterTitle: "Ubah Pemain & Lapangan",
    addPlayer: "Tambah Pemain",
    removePlayer: "Hapus",
    reactivatePlayer: "Aktifkan kembali",
    inactivePlayers: "Pemain Tidak Aktif",
    applyChanges: "Terapkan Perubahan",
    rosterWarning: "Ronde saat ini akan dibuat ulang dan skor direset",
    rosterWarningTitle: "Menerapkan perubahan akan memulai ulang ronde ini",
    rosterWarningRegenerate: "Tim untuk ronde saat ini akan diacak dan dibuat ulang.",
    rosterWarningScores: "Skor apa pun yang sudah dimasukkan untuk ronde ini akan dihapus.",
    rosterWarningNewPlayers: "Pemain baru langsung bergabung dan ditambahkan ke ronde ini.",
    rosterWarningSafe: "Skor dari ronde sebelumnya yang sudah selesai tetap disimpan.",
    minPlayersWarning: "Butuh setidaknya 4 pemain aktif",
    courtsReduced: "Lapangan dikurangi menjadi {courts} (pemain aktif tidak cukup)",
    playerInactive: "Tidak aktif",
    mixedPairsWarning: "Pasangan campuran membutuhkan jumlah pemain pria dan wanita yang sama",
    arrangeFirstRound: "Atur Ronde Pertama",
    arrangeFirstRoundTitle: "Atur Ronde Pertama",
    arrangeFirstRoundHelp: "Ketuk atau klik satu kartu pemain, lalu ketuk slot lain untuk menukar mereka. Gunakan baris bangku cadangan untuk menukar pemain masuk dan keluar. Ini bekerja sama di ponsel dan desktop.",
    resetFirstRound: "Reset Perubahan",
    firstRoundUpdated: "Ronde pertama diperbarui",
    manualFirstRoundInvalid: "Setiap pemain aktif harus muncul tepat satu kali dalam pengaturan ronde pertama.",
    manualFirstRoundMixedPairs: "Pasangan campuran membutuhkan satu pria dan satu wanita di setiap tim.",
    manualFirstRoundBenchSlot: "Slot bangku {number}",
    removePlayerTitle: "Hapus Pemain",
    removePlayerMessage: "Bagaimana Anda ingin menghapus {player}?",
    removePlayerExplanation: "Jadikan Tidak Aktif: Pemain tetap di papan peringkat tetapi tidak akan ditugaskan ke pertandingan. Hapus Sepenuhnya: Pemain dihapus seluruhnya dari turnamen.",
    makeInactive: "Jadikan Tidak Aktif (tetap di papan peringkat)",
    removeCompletely: "Hapus Sepenuhnya (hapus dari turnamen)",
    removePlayerFinalTitle: "Apakah Anda yakin?",
    removePlayerFinalMessage: "Ini akan menghapus {player} dan semua skornya secara permanen dari turnamen. Tindakan ini tidak dapat dibatalkan."
  },
  tvMode: {
    subtitle: "Tampilkan halaman ini ke TV untuk menampilkan papan peringkat dan lapangan secara langsung",
    round: "Ronde {round}",
    leaderboard: "Papan Peringkat",
    lastRound: "Ronde terakhir",
    onCourt: "Sedang di lapangan",
    noGames: "Belum ada pertandingan aktif",
    bench: "Menunggu ronde ini",
    missingStateTitle: "Mode TV membutuhkan tautan turnamen",
    missingStateBody: "Buka mode TV dari turnamen yang aktif atau selesai untuk menampilkan datanya di layar.",
    openButton: "Buka mode TV",
  },
  theme: {
    switchToDark: 'Beralih ke mode gelap',
    switchToLight: 'Beralih ke mode terang',
    toggleLabel: 'Alihkan mode warna',
  },
  playerSetup: {
    title: "Siapa yang bermain?",
    addPlayer: "Tambah Pemain",
    playerName: "Pemain",
    playerRequired: "Nama pemain wajib diisi",
    formatTitle: "Gaya turnamen",
    formatAmericano: "Permainan Americano",
    formatMexicano: "Permainan Mexicano",
    courtsTitle: "Jumlah Lapangan",
    court: "Lapangan",
    courts: "Lapangan",
    startTournament: "Mulai Turnamen",
    loadTeam: "Muat tim",
    saveTeam: "Simpan tim",
    loadTeamTitle: "Muat tim tersimpan",
    saveTeamTitle: "Simpan tim ini",
    teamCode: "Nama tim",
    loadTeamHint: "Masukkan nama tim yang mudah diingat untuk menggunakan kembali daftar pemainnya.",
    saveTeamHint: "Beri daftar pemain ini nama yang mudah diingat agar bisa digunakan kembali lain kali.",
    savedTeamsTitle: "Tim tersimpan Anda",
    noSavedTeams: "Belum ada tim tersimpan di perangkat ini.",
    teamNameRequired: "Silakan masukkan nama tim",
    noPlayersToSave: "Tambahkan setidaknya satu nama pemain sebelum menyimpan",
    teamNotFound: "Tidak ada tim tersimpan dengan nama itu",
    teamSaved: "Tim disimpan",
    teamSaveFailed: "Tim tidak dapat disimpan. Silakan coba lagi.",
    teamSavedLocally: "Tim disimpan di perangkat ini. Ketersediaan untuk dibagikan belum dikonfirmasi.",
    teamLoaded: "Tim dimuat",
    updatingTeam: "Menyimpan akan memperbarui tim Anda \"{name}\".",
    teamNameTaken: "Nama itu sudah dipakai. Ketuk saran atau masukkan nama lain.",
    suggestionLabel: "Nama yang disarankan",
    load: "Muat",
    createTeam: "Buat tim",
    pinFourDigits: "PIN (4 angka)",
    pinEnterPrompt: "Masukkan PIN 4 angka tim.",
    pinCreateWarning: "Anda memerlukan PIN ini untuk memuat tim nanti. PIN tidak dapat dipulihkan \u2014 jika lupa, Anda harus membuat tim baru.",
    pinInvalid: "PIN harus 4 angka.",
    pinIncorrect: "PIN salah. PIN tidak dapat dipulihkan \u2014 buat tim baru jika lupa.",
    notEnoughPlayers: "Butuh setidaknya {count} pemain untuk {courts} lapangan",
    duplicateName: "Nama ganda",
    roundTypeTitle: "Tipe ronde",
    roundTypePoints: "Poin",
    roundTypeTime: "Berbasis waktu",
    targetPoints: "Poin yang dituju",
    roundMinutes: "Menit per ronde",
    timerHint: "Peluit dan spanduk akan muncul saat pengatur waktu mencapai 0.",
    mixedPairsLabel: "Pasangan campuran (tim P+W)",
    mexicanoPairingTitle: "Pemasangan Mexicano",
    mexicanoPairingHint: "Pilih cara setiap lapangan berisi empat orang dibagi menjadi tim.",
    mexicanoPairingStandard: "Opsi 1: #1 + #3 vs #2 + #4",
    mexicanoPairingStandardDescription: "Memasangkan pemain peringkat 1 dengan peringkat 3, dan peringkat 2 dengan peringkat 4 di setiap lapangan.",
    mexicanoPairingAlternate: "Opsi 2: #1 + #4 vs #2 + #3",
    mexicanoPairingAlternateDescription: "Memasangkan pemain teratas dengan peringkat 4, dan dua pemain tengah bersama di setiap lapangan.",
    gender: "Jenis kelamin",
    male: "Pria",
    female: "Wanita",
    genderBalance: "Pasangan campuran membutuhkan jumlah pemain pria dan wanita yang sama."
  },
  rules: {
    titleAmericano: 'Cara Kerja Americano',
    titleMexicano: 'Cara Kerja Mexicano',
    teamSetupTitle: 'Penyusunan Tim',
    teamSetupAmericano: 'Pemain ditugaskan ke tim secara acak sebelum setiap ronde untuk memastikan kombinasi tim dan lawan yang berbeda.',
    teamPattern13v24: '#1+#3 melawan #2+#4',
    teamPattern14v23: '#1+#4 melawan #2+#3',
    teamSetupMexicano: 'Pemasangan mengikuti papan peringkat langsung. Pemain dikelompokkan menjadi empat berdasarkan peringkat (4 teratas, 4 berikutnya, dst). Di setiap lapangan: {pattern}. Lapangan berikutnya mengikuti pola yang sama. Ini membuat pemain kuat melawan pemain kuat dan pemain lebih lemah melawan yang lebih lemah — tujuannya adalah skor individu yang tinggi, bukan satu pasangan pemenang.',
    scoringSystemTitle: 'Sistem Penilaian',
    scoringSystem: 'Setiap ronde dimainkan hingga jumlah poin tertentu atau selama waktu tertentu. Poin diberikan secara individu – misalnya, jika sebuah tim menang 13–8, setiap pemain di tim pemenang mendapat 13 poin, dan pemain yang kalah mendapat 8.',
    winnerTitle: 'Pemenang',
    winner: 'Pemain dengan poin terbanyak secara keseluruhan menang dan mendapat tepuk tangan dari yang lain. :)',
    faqTitle: 'Pertanyaan yang sering diajukan',
    faqFormatsQ: 'Apa bedanya Americano dan Mexicano?',
    faqFormatsA: 'Di Americano, pemain dipasangkan secara acak setiap ronde sehingga semua bermain dengan dan melawan semua. Di Mexicano, pasangan mengikuti papan peringkat langsung dan mempertemukan pemain dengan peringkat serupa.',
    faqSportsQ: 'Bisakah dipakai untuk olahraga selain padel?',
    faqSportsA: 'Bisa. Meski dibuat untuk padel, format Americano dan Mexicano cocok untuk pickleball, tenis, tenis meja, bulu tangkis, dan permainan apa pun yang dihitung dengan poin.',
    faqFreeQ: 'Apakah gratis dan perlu akun?',
    faqFreeA: 'Sepenuhnya gratis tanpa pendaftaran. Turnamen berjalan di peramban Anda dan bisa dipakai offline.',
    faqPlayersQ: 'Berapa banyak pemain dan lapangan yang bisa dipakai?',
    faqPlayersA: 'Berapa pun jumlah pemain di satu atau beberapa lapangan. Aplikasi merotasi pemain secara otomatis setiap ronde.'
  },
  privacy: {
    title: "Kebijakan Privasi",
    lastUpdated: "Terakhir diperbarui",
    dataCollection: "Pengumpulan Data",
    dataCollectionText: "Vamos Tamos tidak mengumpulkan atau menyimpan data pribadi apa pun. Semua data turnamen tetap di perangkat Anda.",
    localStorage: "Penyimpanan Lokal",
    localStorageText: "Data turnamen disimpan secara lokal di localStorage browser Anda untuk mempertahankan status permainan. Anda dapat menghapus data ini kapan saja melalui pengaturan browser Anda.",
    cookies: "Cookie",
    cookiesText: "Aplikasi ini tidak menggunakan cookie untuk pelacakan. Hanya penyimpanan browser penting (localStorage) yang digunakan untuk fungsi turnamen.",
    thirdParty: "Layanan Pihak Ketiga",
    thirdPartyText: "Kami menggunakan Vercel Web Analytics untuk mengumpulkan data penggunaan anonim dan agregat (tampilan halaman, jumlah pengunjung). Data ini berfokus pada privasi dan tidak melacak pengguna individu, tidak menggunakan cookie, atau mengumpulkan informasi pribadi. Pelajari lebih lanjut di vercel.com/analytics.",
    rights: "Hak Anda (GDPR/CCPA)",
    rightsText: "Karena tidak ada data pribadi yang dikumpulkan atau diproses, Anda memegang kendali penuh atas data Anda. Anda dapat menghapus semua data turnamen yang tersimpan secara lokal dengan membersihkan localStorage browser Anda.",
    contact: "Kontak",
    contactText: "Untuk pertanyaan privasi, hubungi: the.adnan@gmail.com",
    backHome: "Kembali ke Beranda"
  }
};
